import React from "react";
import { Box, Typography } from "@mui/material";
import { usePermissions } from "@/context/PermissionsContext";
import { BOUNCER_PERMISSIONS } from "@/constants/bouncerPermissions";

export default function RfqGate({ children }: { children: React.ReactNode }) {
  const { hasPermission } = usePermissions();

  if (!hasPermission(BOUNCER_PERMISSIONS.RFQ_VIEW)) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="body1">RFQs are not available for this account yet.</Typography>
      </Box>
    );
  }

  return <>{children}</>;
}
